import React, { useState } from 'react';
import { SaveIcon, AlertCircleIcon, CheckCircleIcon } from 'lucide-react';
export const SettingsPage = () => {
  const [activeTab, setActiveTab] = useState('general');
  const [saveSuccess, setSaveSuccess] = useState(false);
  const [formData, setFormData] = useState({
    siteName: 'SellUp',
    siteDescription: 'Your trusted marketplace for used electronics',
    supportEmail: 'support@sellup.com',
    supportPhone: '+1 (123) 456-7890',
    platformFee: 5,
    minimumPayout: 50,
    payoutSchedule: 'weekly',
    allowGuestCheckout: true,
    requireEmailVerification: true,
    enableDealerReviews: true,
    enableProductReviews: true,
    maxImagesPerProduct: 8,
    defaultCurrency: 'USD',
    timeZone: 'UTC',
    dateFormat: 'MM/DD/YYYY',
    googleAnalyticsId: 'UA-12345678-1'
  });
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const {
      name,
      value,
      type
    } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? (e.target as HTMLInputElement).checked : type === 'number' ? parseFloat(value) : value
    });
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // In a real app, this would save to an API
    console.log('Settings saved:', formData);
    // Show success message
    setSaveSuccess(true);
    setTimeout(() => setSaveSuccess(false), 3000);
  };
  return <div className="space-y-6" data-id="element-1743">
      <div className="flex justify-between items-center" data-id="element-1744">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-1745">Settings</h1>
        {saveSuccess && <div className="flex items-center text-green-700 bg-green-50 px-4 py-2 rounded-md" data-id="element-1746">
            <CheckCircleIcon className="h-5 w-5 mr-2" data-id="element-1747" />
            Settings saved successfully
          </div>}
      </div>
      {/* Settings Tabs */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" data-id="element-1748">
        <div className="border-b border-gray-200" data-id="element-1749">
          <nav className="flex -mb-px" data-id="element-1750">
            <button className={`py-4 px-6 text-sm font-medium ${activeTab === 'general' ? 'border-b-2 border-blue-500 text-blue-600' : 'text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} onClick={() => setActiveTab('general')} data-id="element-1751">
              General
            </button>
            <button className={`py-4 px-6 text-sm font-medium ${activeTab === 'payment' ? 'border-b-2 border-blue-500 text-blue-600' : 'text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} onClick={() => setActiveTab('payment')} data-id="element-1752">
              Payment & Fees
            </button>
            <button className={`py-4 px-6 text-sm font-medium ${activeTab === 'users' ? 'border-b-2 border-blue-500 text-blue-600' : 'text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} onClick={() => setActiveTab('users')} data-id="element-1753">
              Users & Permissions
            </button>
            <button className={`py-4 px-6 text-sm font-medium ${activeTab === 'advanced' ? 'border-b-2 border-blue-500 text-blue-600' : 'text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} onClick={() => setActiveTab('advanced')} data-id="element-1754">
              Advanced
            </button>
          </nav>
        </div>
        <form onSubmit={handleSubmit} data-id="element-1755">
          <div className="p-6" data-id="element-1756">
            {/* General Settings */}
            {activeTab === 'general' && <div className="space-y-6" data-id="element-1757">
                <div data-id="element-1758">
                  <h3 className="text-lg font-medium text-gray-900" data-id="element-1759">
                    Site Information
                  </h3>
                  <p className="mt-1 text-sm text-gray-500" data-id="element-1760">
                    Basic information about your marketplace.
                  </p>
                </div>
                <div className="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6" data-id="element-1761">
                  <div className="sm:col-span-3" data-id="element-1762">
                    <label htmlFor="siteName" className="block text-sm font-medium text-gray-700" data-id="element-1763">
                      Site Name
                    </label>
                    <div className="mt-1" data-id="element-1764">
                      <input type="text" name="siteName" id="siteName" value={formData.siteName} onChange={handleInputChange} className="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md" data-id="element-1765" />
                    </div>
                  </div>
                  <div className="sm:col-span-3" data-id="element-1766">
                    <label htmlFor="defaultCurrency" className="block text-sm font-medium text-gray-700" data-id="element-1767">
                      Default Currency
                    </label>
                    <div className="mt-1" data-id="element-1768">
                      <select id="defaultCurrency" name="defaultCurrency" value={formData.defaultCurrency} onChange={handleInputChange} className="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md" data-id="element-1769">
                        <option value="USD" data-id="element-1770">USD - US Dollar</option>
                        <option value="EUR" data-id="element-1771">EUR - Euro</option>
                        <option value="GBP" data-id="element-1772">GBP - British Pound</option>
                        <option value="JPY" data-id="element-1773">JPY - Japanese Yen</option>
                        <option value="AUD" data-id="element-1774">AUD - Australian Dollar</option>
                        <option value="CAD" data-id="element-1775">CAD - Canadian Dollar</option>
                        <option value="SGD" data-id="element-1776">SGD - Singapore Dollar</option>
                      </select>
                    </div>
                  </div>
                  <div className="sm:col-span-6" data-id="element-1777">
                    <label htmlFor="siteDescription" className="block text-sm font-medium text-gray-700" data-id="element-1778">
                      Site Description
                    </label>
                    <div className="mt-1" data-id="element-1779">
                      <textarea id="siteDescription" name="siteDescription" rows={3} value={formData.siteDescription} onChange={handleInputChange} className="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md" data-id="element-1780" />
                    </div>
                    <p className="mt-2 text-sm text-gray-500" data-id="element-1781">
                      Brief description of your marketplace. This will be used
                      for SEO.
                    </p>
                  </div>
                </div>
                <div className="pt-6 border-t border-gray-200" data-id="element-1782">
                  <h3 className="text-lg font-medium text-gray-900" data-id="element-1783">
                    Contact Information
                  </h3>
                  <p className="mt-1 text-sm text-gray-500" data-id="element-1784">
                    How customers can reach your support team.
                  </p>
                </div>
                <div className="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6" data-id="element-1785">
                  <div className="sm:col-span-3" data-id="element-1786">
                    <label htmlFor="supportEmail" className="block text-sm font-medium text-gray-700" data-id="element-1787">
                      Support Email
                    </label>
                    <div className="mt-1" data-id="element-1788">
                      <input type="email" name="supportEmail" id="supportEmail" value={formData.supportEmail} onChange={handleInputChange} className="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md" data-id="element-1789" />
                    </div>
                  </div>
                  <div className="sm:col-span-3" data-id="element-1790">
                    <label htmlFor="supportPhone" className="block text-sm font-medium text-gray-700" data-id="element-1791">
                      Support Phone
                    </label>
                    <div className="mt-1" data-id="element-1792">
                      <input type="text" name="supportPhone" id="supportPhone" value={formData.supportPhone} onChange={handleInputChange} className="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md" data-id="element-1793" />
                    </div>
                  </div>
                </div>
              </div>}
            {/* Payment & Fees Settings */}
            {activeTab === 'payment' && <div className="space-y-6" data-id="element-1794">
                <div data-id="element-1795">
                  <h3 className="text-lg font-medium text-gray-900" data-id="element-1796">
                    Platform Fees
                  </h3>
                  <p className="mt-1 text-sm text-gray-500" data-id="element-1797">
                    Configure the fees charged to dealers for using the
                    platform.
                  </p>
                </div>
                <div className="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6" data-id="element-1798">
                  <div className="sm:col-span-3" data-id="element-1799">
                    <label htmlFor="platformFee" className="block text-sm font-medium text-gray-700" data-id="element-1800">
                      Platform Fee (%)
                    </label>
                    <div className="mt-1 relative rounded-md shadow-sm" data-id="element-1801">
                      <input type="number" name="platformFee" id="platformFee" min="0" max="100" step="0.01" value={formData.platformFee} onChange={handleInputChange} className="focus:ring-blue-500 focus:border-blue-500 block w-full pr-12 sm:text-sm border-gray-300 rounded-md" data-id="element-1802" />
                      <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none" data-id="element-1803">
                        <span className="text-gray-500 sm:text-sm" data-id="element-1804">%</span>
                      </div>
                    </div>
                    <p className="mt-2 text-sm text-gray-500" data-id="element-1805">
                      Percentage fee charged on each transaction.
                    </p>
                  </div>
                </div>
                <div className="pt-6 border-t border-gray-200" data-id="element-1806">
                  <h3 className="text-lg font-medium text-gray-900" data-id="element-1807">
                    Payout Settings
                  </h3>
                  <p className="mt-1 text-sm text-gray-500" data-id="element-1808">
                    Configure how and when dealers receive their payments.
                  </p>
                </div>
                <div className="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6" data-id="element-1809">
                  <div className="sm:col-span-3" data-id="element-1810">
                    <label htmlFor="minimumPayout" className="block text-sm font-medium text-gray-700" data-id="element-1811">
                      Minimum Payout Amount
                    </label>
                    <div className="mt-1 relative rounded-md shadow-sm" data-id="element-1812">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1813">
                        <span className="text-gray-500 sm:text-sm" data-id="element-1814">$</span>
                      </div>
                      <input type="number" name="minimumPayout" id="minimumPayout" min="0" step="0.01" value={formData.minimumPayout} onChange={handleInputChange} className="focus:ring-blue-500 focus:border-blue-500 block w-full pl-7 sm:text-sm border-gray-300 rounded-md" data-id="element-1815" />
                    </div>
                  </div>
                  <div className="sm:col-span-3" data-id="element-1816">
                    <label htmlFor="payoutSchedule" className="block text-sm font-medium text-gray-700" data-id="element-1817">
                      Payout Schedule
                    </label>
                    <div className="mt-1" data-id="element-1818">
                      <select id="payoutSchedule" name="payoutSchedule" value={formData.payoutSchedule} onChange={handleInputChange} className="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md" data-id="element-1819">
                        <option value="daily" data-id="element-1820">Daily</option>
                        <option value="weekly" data-id="element-1821">Weekly</option>
                        <option value="biweekly" data-id="element-1822">Bi-weekly</option>
                        <option value="monthly" data-id="element-1823">Monthly</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>}
            {/* Users & Permissions Settings */}
            {activeTab === 'users' && <div className="space-y-6" data-id="element-1824">
                <div className="flex justify-between items-start" data-id="element-1825">
                  <div data-id="element-1826">
                    <h3 className="text-lg font-medium text-gray-900" data-id="element-1827">
                      User Settings
                    </h3>
                    <p className="mt-1 text-sm text-gray-500" data-id="element-1828">
                      Configure user-related settings and permissions.
                    </p>
                  </div>
                  <button type="button" className="bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 transition-colors" data-id="element-1829">
                    Manage Users
                  </button>
                </div>
                <div className="space-y-4" data-id="element-1830">
                  <div className="flex items-start" data-id="element-1831">
                    <div className="flex items-center h-5" data-id="element-1832">
                      <input id="allowGuestCheckout" name="allowGuestCheckout" type="checkbox" checked={formData.allowGuestCheckout} onChange={handleInputChange} className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded" data-id="element-1833" />
                    </div>
                    <div className="ml-3 text-sm" data-id="element-1834">
                      <label htmlFor="allowGuestCheckout" className="font-medium text-gray-700" data-id="element-1835">
                        Allow guest checkout
                      </label>
                      <p className="text-gray-500" data-id="element-1836">
                        Allow customers to checkout without creating an account.
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-1837">
                    <div className="flex items-center h-5" data-id="element-1838">
                      <input id="requireEmailVerification" name="requireEmailVerification" type="checkbox" checked={formData.requireEmailVerification} onChange={handleInputChange} className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded" data-id="element-1839" />
                    </div>
                    <div className="ml-3 text-sm" data-id="element-1840">
                      <label htmlFor="requireEmailVerification" className="font-medium text-gray-700" data-id="element-1841">
                        Require email verification
                      </label>
                      <p className="text-gray-500" data-id="element-1842">
                        Require users to verify their email address before they
                        can log in.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="pt-6 border-t border-gray-200" data-id="element-1843">
                  <h3 className="text-lg font-medium text-gray-900" data-id="element-1844">
                    Review Settings
                  </h3>
                  <p className="mt-1 text-sm text-gray-500" data-id="element-1845">
                    Configure how reviews work on your marketplace.
                  </p>
                </div>
                <div className="space-y-4" data-id="element-1846">
                  <div className="flex items-start" data-id="element-1847">
                    <div className="flex items-center h-5" data-id="element-1848">
                      <input id="enableDealerReviews" name="enableDealerReviews" type="checkbox" checked={formData.enableDealerReviews} onChange={handleInputChange} className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded" data-id="element-1849" />
                    </div>
                    <div className="ml-3 text-sm" data-id="element-1850">
                      <label htmlFor="enableDealerReviews" className="font-medium text-gray-700" data-id="element-1851">
                        Enable dealer reviews
                      </label>
                      <p className="text-gray-500" data-id="element-1852">
                        Allow customers to leave reviews for dealers.
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-1853">
                    <div className="flex items-center h-5" data-id="element-1854">
                      <input id="enableProductReviews" name="enableProductReviews" type="checkbox" checked={formData.enableProductReviews} onChange={handleInputChange} className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded" data-id="element-1855" />
                    </div>
                    <div className="ml-3 text-sm" data-id="element-1856">
                      <label htmlFor="enableProductReviews" className="font-medium text-gray-700" data-id="element-1857">
                        Enable product reviews
                      </label>
                      <p className="text-gray-500" data-id="element-1858">
                        Allow customers to leave reviews for products.
                      </p>
                    </div>
                  </div>
                </div>
              </div>}
            {/* Advanced Settings */}
            {activeTab === 'advanced' && <div className="space-y-6" data-id="element-1859">
                <div data-id="element-1860">
                  <h3 className="text-lg font-medium text-gray-900" data-id="element-1861">
                    Advanced Settings
                  </h3>
                  <p className="mt-1 text-sm text-gray-500" data-id="element-1862">
                    Additional configuration options for your marketplace.
                  </p>
                </div>
                <div className="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6" data-id="element-1863">
                  <div className="sm:col-span-3" data-id="element-1864">
                    <label htmlFor="maxImagesPerProduct" className="block text-sm font-medium text-gray-700" data-id="element-1865">
                      Max Images Per Product
                    </label>
                    <div className="mt-1" data-id="element-1866">
                      <input type="number" name="maxImagesPerProduct" id="maxImagesPerProduct" min="1" max="20" value={formData.maxImagesPerProduct} onChange={handleInputChange} className="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md" data-id="element-1867" />
                    </div>
                    <p className="mt-2 text-sm text-gray-500" data-id="element-1868">
                      Maximum number of images dealers can upload per product.
                    </p>
                  </div>
                  <div className="sm:col-span-3" data-id="element-1869">
                    <label htmlFor="timeZone" className="block text-sm font-medium text-gray-700" data-id="element-1870">
                      Time Zone
                    </label>
                    <div className="mt-1" data-id="element-1871">
                      <select id="timeZone" name="timeZone" value={formData.timeZone} onChange={handleInputChange} className="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md" data-id="element-1872">
                        <option value="UTC" data-id="element-1873">UTC</option>
                        <option value="America/New_York" data-id="element-1874">
                          Eastern Time (ET)
                        </option>
                        <option value="America/Chicago" data-id="element-1875">
                          Central Time (CT)
                        </option>
                        <option value="America/Denver" data-id="element-1876">
                          Mountain Time (MT)
                        </option>
                        <option value="America/Los_Angeles" data-id="element-1877">
                          Pacific Time (PT)
                        </option>
                        <option value="Asia/Singapore" data-id="element-1878">
                          Singapore Time (SGT)
                        </option>
                      </select>
                    </div>
                  </div>
                  <div className="sm:col-span-3" data-id="element-1879">
                    <label htmlFor="dateFormat" className="block text-sm font-medium text-gray-700" data-id="element-1880">
                      Date Format
                    </label>
                    <div className="mt-1" data-id="element-1881">
                      <select id="dateFormat" name="dateFormat" value={formData.dateFormat} onChange={handleInputChange} className="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md" data-id="element-1882">
                        <option value="MM/DD/YYYY" data-id="element-1883">MM/DD/YYYY</option>
                        <option value="DD/MM/YYYY" data-id="element-1884">DD/MM/YYYY</option>
                        <option value="YYYY-MM-DD" data-id="element-1885">YYYY-MM-DD</option>
                      </select>
                    </div>
                  </div>
                  <div className="sm:col-span-3" data-id="element-1886">
                    <label htmlFor="googleAnalyticsId" className="block text-sm font-medium text-gray-700" data-id="element-1887">
                      Google Analytics ID
                    </label>
                    <div className="mt-1" data-id="element-1888">
                      <input type="text" name="googleAnalyticsId" id="googleAnalyticsId" value={formData.googleAnalyticsId} onChange={handleInputChange} className="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md" data-id="element-1889" />
                    </div>
                    <p className="mt-2 text-sm text-gray-500" data-id="element-1890">
                      Your Google Analytics tracking ID (e.g. UA-12345678-1).
                    </p>
                  </div>
                </div>
                <div className="pt-6 border-t border-gray-200" data-id="element-1891">
                  <div className="rounded-md bg-yellow-50 p-4" data-id="element-1892">
                    <div className="flex" data-id="element-1893">
                      <div className="flex-shrink-0" data-id="element-1894">
                        <AlertCircleIcon className="h-5 w-5 text-yellow-400" data-id="element-1895" />
                      </div>
                      <div className="ml-3" data-id="element-1896">
                        <h3 className="text-sm font-medium text-yellow-800" data-id="element-1897">
                          Attention needed
                        </h3>
                        <div className="mt-2 text-sm text-yellow-700" data-id="element-1898">
                          <p data-id="element-1899">
                            Changing advanced settings may affect your
                            marketplace's functionality. Please make sure you
                            understand the implications before saving changes.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>}
          </div>
          {/* Form Actions */}
          <div className="px-6 py-4 bg-gray-50 border-t border-gray-200 flex justify-end" data-id="element-1900">
            <button type="button" className="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 mr-3" data-id="element-1901">
              Cancel
            </button>
            <button type="submit" className="bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 transition-colors flex items-center" data-id="element-1902">
              <SaveIcon className="h-5 w-5 mr-2" data-id="element-1903" />
              Save Settings
            </button>
          </div>
        </form>
      </div>
    </div>;
};